/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON, FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON, } from './FxIdApplicationCrossPlayHandlersQuestEventDto';
import { FxIdDomainCrossPlayQuestTargetTypeFromJSON, FxIdDomainCrossPlayQuestTargetTypeToJSON, } from './FxIdDomainCrossPlayQuestTargetType';
import { FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON, FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON, } from './FxIdApplicationCrossPlayHandlersUserQuestDtoProgress';
import { FxIdDomainCrossPlayQuestDependencyTypeFromJSON, FxIdDomainCrossPlayQuestDependencyTypeToJSON, } from './FxIdDomainCrossPlayQuestDependencyType';
/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersUserQuestDto interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersUserQuestDto(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('DependencyType' in value) || value['DependencyType'] === undefined)
        return false;
    if (!('TargetType' in value) || value['TargetType'] === undefined)
        return false;
    if (!('Event' in value) || value['Event'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSON(json) {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'DependentQuestId': json['DependentQuestId'] == null ? undefined : json['DependentQuestId'],
        'DependencyType': FxIdDomainCrossPlayQuestDependencyTypeFromJSON(json['DependencyType']),
        'TargetType': FxIdDomainCrossPlayQuestTargetTypeFromJSON(json['TargetType']),
        'Event': FxIdApplicationCrossPlayHandlersQuestEventDtoFromJSON(json['Event']),
        'Progress': json['Progress'] == null ? undefined : FxIdApplicationCrossPlayHandlersUserQuestDtoProgressFromJSON(json['Progress']),
    };
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoToJSON(json) {
    return FxIdApplicationCrossPlayHandlersUserQuestDtoToJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersUserQuestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'DependentQuestId': value['DependentQuestId'],
        'DependencyType': FxIdDomainCrossPlayQuestDependencyTypeToJSON(value['DependencyType']),
        'TargetType': FxIdDomainCrossPlayQuestTargetTypeToJSON(value['TargetType']),
        'Event': FxIdApplicationCrossPlayHandlersQuestEventDtoToJSON(value['Event']),
        'Progress': FxIdApplicationCrossPlayHandlersUserQuestDtoProgressToJSON(value['Progress']),
    };
}
//# sourceMappingURL=FxIdApplicationCrossPlayHandlersUserQuestDto.js.map